import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import {IUser} from "../../../../models/leads/leads.model";
import {debounce} from "../../../../helper/debounce";
import { PROFILE_DATA_SERVICE, ProfileDataService } from '../../../../services/profile/profile-data.service';

@Component({
  selector: 'fi-forward-user',
  templateUrl: './forward-user.component.html',
  styleUrls: ['./forward-user.component.scss'],
  standalone: false,
})
export class ForwardUserComponent implements OnChanges {

  @Output() userIdSelected = new EventEmitter<number>();
  @Output() menuOpened = new EventEmitter<boolean>();
  @Input() userId?: number;

  tabTypes = {dropdown: 'dropdown', input: 'input'};
  selectedTab = this.tabTypes.dropdown;
  selectActiveValue = false;
  usersByArea: IUser[] = [];
  usersByHierarchy: IUser[] = [];
  suggestedData = {
    byArea: this.usersByArea as IUser[],
    byHierarchy: this.usersByHierarchy as IUser[],
  };
  searchedText = '';
  doSearch = debounce(() => this.filterData());
  showSuggestions = false;
  currentSearchText = '';

  constructor(
    @Inject(PROFILE_DATA_SERVICE) private readonly profileDataService: ProfileDataService,
  ) {
    profileDataService.getSubstitutes().subscribe(({success, data}) => {
      if (success) {
        //this.usersByArea = data;
        this.usersByHierarchy = data;
        this.updateSelection();
      }
    });
  }

  ngOnChanges(): void {
    this.updateSelection();
  }

  toggleSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = !this.selectActive;
    this.searchedText = this.currentSearchText;

    if (this.selectActive) {
      this.suggestedData = {
        byArea: this.usersByArea,
        byHierarchy: this.usersByHierarchy,
      };
    }
  }

  showSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = true;

    this.suggestedData = {
      byArea: this.usersByArea,
      byHierarchy: this.usersByHierarchy,
    };
  }

  private updateSelection(): void {
    const user = [...this.usersByArea, ...this.usersByHierarchy].find(user => user.Id === this.userId);

    if (user) {
      this.currentSearchText = this.searchedText = user.FirstName + ' ' + user.LastName;
    }
  }

  private filterData(): void {
    const value = this.searchedText;

    if (!value) {
      this.showSuggestions = false;
      setTimeout(_ => {
        this.suggestedData = {
          byArea: this.usersByArea,
          byHierarchy: this.usersByHierarchy,
        };
      }, 300);
      return;
    }

    const searchedValue = value.split(' ').filter(item => item !== '');
    this.suggestedData = {
      byArea: this.getFilters(searchedValue, [...this.usersByArea]),
      byHierarchy: this.getFilters(searchedValue, [...this.usersByHierarchy])
    };
  }

  private getFilters(searchedValue: string[], allItems: IUser[]): any {
    const result = [];
    searchedValue.forEach(item => {
      const arr = allItems.filter((elem, index) => {
        const expression = new RegExp(`^${item}| ${item}`, 'gmi');
        const match = expression.test(elem.FirstName + ' ' + elem.LastName);
        if (match) {
          allItems.splice(index, 1);
        }
        return match;
      });

      result.push(...arr);
    });

    return result;
  }

  selectResultItem($event: Event, result: IUser): void {
    this.selectActive = false;
    this.currentSearchText = this.searchedText = result.FirstName + ' ' + result.LastName;
    $event.stopPropagation();
    this.userIdSelected.emit(result.Id);
  }

  get selectActive(): boolean {
    return this.selectActiveValue;
  }

  set selectActive(value: boolean) {
    this.selectActiveValue = value;
    this.menuOpened.emit(this.selectActiveValue);
  }
}
